// extracted by mini-css-extract-plugin
module.exports = {"app__shake_gallery_title":"shakeGallery_app__shake_gallery_title__a2iqh"};